<template>
<div class="customerWrapper_copy">
    <div class="customer_header">
        <span v-show="targetUserName" >{{$t('other.a362')}}{{targetUserName}} {{$t('other.a363')}}</span>
        <span v-show="!targetUserName" ></span>
        <span  class="merber" @click="closeDia()">{{$t('other.a5')}}</span>
    </div>
    <div class="customerBox">
      <div class="customer_left">
          <div class="user_num">{{$t('other.a364')}}</div>
          <ul>
              <li :class="{'shop_message':true,'active':targetIndex == index} "  v-for="(item,index) in userList" :key="index" @click="targetUser(item,index)">
                  <div class="head_img_box">
                      <!-- <img src="../pages/customer/11.png"/> -->
                      <i class="iconfont icon-kehuAx"></i>
                  </div>
                  <div class="desc_message">
                      <div class="user_name">{{item.userName}}</div>
                      <div class="user_name messge_buyer ">{{item.sessionInfo}}</div>
                  </div>
              </li>
          </ul>

      </div>
      <div class="customer_right">
         <div id="dialogue_box" class="customer_chat_recode">
             <ul>
                 <li :class="{'chat_recode_items':true,'reverse_row':item.type == 'seller'}" v-for="(item,index) in chatingList" :key="index">
                   <div class="messageTime" v-if="item.flag">{{item.flag ? item.time  : ''}}</div>
                    <div style="display:flex" :class="{'reverse_row':item.type == 'seller'}">
                        <div class="pic_box">
                         <!-- <img src="../pages/customer/11.png" /> -->
                         <i v-show="item.type === 'buyer'" class="iconfont icon-kehuAx"></i>
                         <i v-show="item.type === 'seller'" class="iconfont icon-kefucopy"></i>
                        </div>
                        <div v-if="item.message.indexOf('images')> -1" :class="{'chat_desc_pic':item.type == 'buyer','reverse_desc_row_pic':item.type == 'seller'}" >
                            <img  v-image-preview :src="item.message" />
                        </div>
                        <div v-if="item.message.indexOf('mp3')> -1" :class="{'chat_desc':item.type == 'buyer','reverse_desc_row':item.type == 'seller'}" >
                            {{$t('other.a366')}}
                        </div>
                        <div v-else :class="{'chat_desc':item.type == 'buyer','reverse_desc_row':item.type == 'seller'}" >{{item.message}}</div>
                        
                        <div v-show="item.type == 'seller' " class="isRead">{{item.read ? $t('other.a365') : $t('other.a367')}}</div>
                    </div>
                 </li>
             </ul>
         </div>
         <div class="middle_content">
             <el-upload
			   class="upload-demo"
			   action="https://erp.shopsbu.com/service/access/upload"
               :headers="token"
			   :on-remove="handleRemove"
			   :on-success="handlePreview"
			   style="filter:alpha(opacity=0);opacity:0;width: 0;height: 0;"
			   list-type="picture">
               <el-button ref="filElem" size="small" type="primary">{{$t('other.a368')}}</el-button>
			 </el-upload>
          
             <!-- <input ref="filElem" type="file" class="upload-file" @change="sentFils" style="filter:alpha(opacity=0);opacity:0;width: 0;height: 0;"> -->
            <i class="iconfont icon-xiangce icon_tubiao" @click="getFilePath()"></i>
            <!-- <i class="iconfont icon-biaoqing icon_tubiao " @click="sentFils()"></i> -->
         </div>
         <div class="textBox_wrapper">
            <textarea class="textBox" v-model="textDesc" contenteditable="true"></textarea>
            <el-button class="sendBtn" type="primary" @click="sendMessage()">{{$t('other.a369')}}</el-button>
         </div>

      </div>
  </div>
</div>

  
</template>

<script>

import api from '../api/moudles/customer'
import utils from '../utils/utils'
import { mapState, mapMutations } from 'vuex'
export default {
data(){
return{
    list:[],
    textDesc:'',
    websock:null,
    targetIndex:null,
    targetUserId:null,
    targetUserName:null,
    messageTo:null,
    div:null,
    fileList: [],
    token:{
        token:JSON.parse(localStorage.getItem('userInfo')).token
    },
    


}
},

computed:{
    ...mapState({
        userId: state => state.shopaccess.userInfo.userId,
        userList: state => state.customer.userList,
        newList: state => state.customer.newList,

       
    }),

    chatingList(){
          if(this.newList){
            let list=[]
            let list2=[]
            this.newList.forEach(p => {
                p.messages.forEach(k => {
                    if(p.reciprocalId === this.targetUserId){
                        list.push({
                            type:k.comeFrom == this.userId ? "seller" : 'buyer',
                            message:k.msg,
                            read:k.read,
                            time:utils.renderTime(k.createTime),
                            time2:Date.parse(new Date(utils.renderTime(k.createTime))),
                            src:'',
                            id:k.chatId

                        })
                    }

                })
               
            })
            let num=0
            if(!list.length) {
                return list
            }
            list[0].flag=true
            for(let i=0;i<list.length;i++){
                if(list[i].time2 -list[num].time2 >5*60*1000){
                    list[i].flag=true
                    num=i
                    console.log(list[i].time)
                }
            }
            console.log('list',list)

            return list

        }
        return []
        

    }
},
props:{
   	receiveItems:{
        type: Object,
        default: () => {}
    },

},

watch:{
    receiveItems(){
        this.readMessage()
        this.init()

    },


  
  newList(){
      if(this.div.scrollHeight !== this.div.scrollTop){
          this.oop()
      }
     
  },
  targetUserId(){
      console.log(this.receiveItems)
      
      if(this.receiveItems.name){
          let arrUser=JSON.parse(JSON.stringify(this.userList))
           
            let obj=[]
            let list =[]
            console.log(arrUser)
            if(arrUser.length > 0){
                    arrUser.forEach((p,index) => {
                        if(p.userAccount == this.targetUserId){
                        console.log(p)
                           list.push(p)
                            obj=[{
                                userName:p.userName,
                                userAccount:p.userAccount,
                                ttp:index
                            }]
                        }
                    })
                     console.log(obj)
                    this.targetUser(obj[0],obj[0].ttp)
            }
      }
      

  }

},

created(){
   this.init()
},
mounted(){
//    this.getClipboardFiles()
   
//绑定事件
window.addEventListener('keydown',this.keyDown);
},
destroyed(){
        window.removeEventListener('keydown',this.keyDown,false);
},
methods:{


    handleRemove(file, fileList) {
    console.log(file, fileList);
    },
    handlePreview(file) {
    console.log(file);
   
    this.textDesc=file.data
    },

    getFilePath(){
    
            const inputFile = this.$refs.filElem
            console.log(inputFile)
            inputFile.click()
          
    },

    //聊天窗口滚动到最底部
    oop(){
        this.$nextTick(function(){
            this.div = document.getElementById('dialogue_box');
            this.div.scrollTop = this.div.scrollHeight;
        })
    },

    init(){
       
         this.targetUserId=this.receiveItems.name
         this.messageTo=this.receiveItems.name
          console.log(this.targetUserId)
           
    },

    //点击会话列表时触发
    targetUser(item,index){
        console.log(item)
        this.targetIndex=index
        this.targetUserName=item.userName
        this.targetUserId=item.userAccount
        this.messageTo=item.userAccount
        this.oop()
        this.readMessage()
    },

    keyDown(e){
				if(e.keyCode === 13) {
					this.sendMessage()
					
				}
			},

     

    sendMessage(){
        if(!this.textDesc){
            this.$message.error(this.$t('other.a370'))
            return
        }
        this.chatingList.push({
            type:'seller',
            message:this.textDesc,
            time:"2021.02.03",
            src:""
        })
       
        api
        .sentMessage({
            comeFrom:this.userId,
            goTo:this.messageTo,
            msg:this.textDesc
        })
        .then(res => {
            if(res.code === 200) {   
                 this.oop()
            }
        })
        this.readMessage()
        this.textDesc=''
       

       
    },

    //标记消息为已读

    readMessage(){

        let list=[]
        this.chatingList.forEach(p => {
            if(p.read === false && p.type == "buyer"){
                list.push({chatId:p.id})
            }
        })
       

       

        api
        .readMessage(list)
        .then(res => {
            if(res.code === 200) {
               
            }
        })

    },

    closeDia(){
        this.$emit('closeDia')

    },

    //获取卖家消息
    getUserMessage(){
        console.log(this.userList)
        console.log(this.list)
        

    },

    //websock链接
    connectWebsocket(){
         const wsuri = "ws://x1754f6150.51mypc.cn:28077/ws";
        this.websock = new WebSocket(wsuri);
        console.log(this.websock)
        this.websock.onmessage = this.websocketonmessage;
        this.websock.onopen = this.websocketonopen;
        this.websock.onerror = this.websocketonerror;
        this.websock.onclose = this.websocketclose;

    },
     websocketonopen(){ //连接建立之后执行send方法发送数据
       this.$message.success(this.$t('other.a371'))
        
      },
      websocketonerror(){//连接建立失败重连
        this.$message.success(this.$t('other.a372'))
      },
      websocketonmessage(e){ //数据接收
        const redata = JSON.parse(e.data);
        console.log('字符串',redata)
      },
      websocketsend(Data){//数据发送
        this.websock.send(Data);
      },
      websocketclose(e){  //关闭
        console.log('断开连接',e);
      },

}
}

</script>
<style lang="scss" scoped>
@import "~@assets/scss/mixins";
.customerWrapper_copy{
      width: 600px;
      position: fixed;
      right: 5px;
      bottom: 50px;
      background-color:#fff;
      box-shadow: 0 2px 12px 0 rgb(173, 173, 173);



      .customer_header{
          height: 30px;
          border-bottom: 1px solid #eeee;
          padding: 5px 10px;
          background-color: #409eff;
          @include flex-between();

          .merber{
              cursor: pointer;
          }

      }
     
     


    .customerBox{
  
    @include flex-between();
    
     align-items: initial;
     height: calc(100vh - 277px);
   
   

    .customer_right{
        flex: 1;

        .icon-kehuAx{
            font-size: 28px;
            color: #409eff;
        }

        .icon-kefucopy{
            font-size: 28px;
            color: orange;
        }

         .textBox_wrapper{
             height: 20%;
             position:relative;

            .textBox{
                width: 95%;
                height: 100%;

            }

            .sendBtn{
                position:absolute;
                bottom: 0;
                right: 20px;
            }

           

            textarea {
                border:none;
                outline: none !important; 
                padding: 5px 10px;
            }
        
        }

         .middle_content{
                padding: 5px 15px;
                border-bottom: 1px solid #eeee;

                .icon_tubiao{
                    font-size: 20px;
                    margin-right: 15px;
                    cursor: pointer;
                }
            }
    

       



        .customer_chat_recode{
            height: 70%;
            width: 100%;
            border-bottom: 1px solid #eeee;
            overflow-y:scroll;

            .isRead{
                font-size: 12px;
                margin-right: 10px;
            }

            .reverse_row{
                flex-direction: row-reverse;
            }

            .chat_recode_items{
                // display: flex;
                // align-items: center;
                // position: relative;
                margin:10px 10px;
                font-size: 14px;

                .messageTime{
                   height: 30px;
                   line-height: 30px;
                   text-align: center;
                   font-size: 15px;
                   color: #C0C4CC;
                   margin: 20px 0;
                   
                    
                }

                .reverse_desc_row{
                     max-width: 150px;
                    word-wrap: break-word;
                    background-color: #409eff;
                    padding: 8px 20px;
                    margin:0 10px 5px 0px;
                    color: #fff;
                    border-radius: 20px 10px 0px 20px !important;
                }

                .reverse_desc_row_pic{
                     max-width: 150px;
                    word-wrap: break-word;
                   
                    padding: 8px 20px;
                    margin:0 0 5px 10px;
                    color: #fff;
                    border-radius: 20px 10px 0px 20px !important;
                }


                .chat_desc{
                    max-width: 150px;
                    word-wrap: break-word;
                    background-color: #C0C4CC;
                    padding: 8px 20px;
                    margin:0 0 5px 0px;
                    
                    border-radius: 10px 20px 20px 0;
                    color: #000;
                }

                .chat_desc_pic{
                    max-width: 150px;
                    word-wrap: break-word;
                  
                    padding: 8px 20px;
                    margin:0 0 5px 10px;
                    
                    border-radius: 10px 20px 20px 0;
                    color: #000;
                }

                .pic_box{
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    overflow: hidden;
                }

                img{
                    width: 100%;
                }

            }

            
        }
    }

    .customer_left{
        width: 150px;
        // height: 100vh;
        overflow: hidden;
        border-right:1px solid #eeee ;

        .icon-kehuAx{
            font-size: 28px;
            color: #409eff;
        }
      
        .user_num{
            padding: 5px;
            border-bottom: 1px #eee solid;
        }
       

        .active{
            background-color: #eeee;

            
        }

        .active::after{
           content:" ";
            background-color:#409eff;
           width: 4px;
           height: 40px;
             position: relative;
            top: 0;
            right: -20px;
            z-index: 66px;
        }

        .shop_message{
        border-bottom: 1px solid #eeee ;
        cursor: pointer;
        @include flex-start() ;

        .head_img_box{
            width: 40px;
            height: 40px;
            border-radius: 50%;
            overflow: hidden;
            @include flex-center()
        }
        .user_name{
            width:80px ;
            font-size: 14px;
            @include ellipsis()
        }

        img{
            width: 100%;
        }
        .desc_message{
            margin-left: 5px;

            .messge_buyer{
                color: #909399;
                font-size: 12px;
                margin-top: 3px;
            }
        }
       
    }
        

    }
    
}
}

</style>